<template>
  <ModalConfirmation
    :class="$style.headerFontSize"
    :showModal="true"
    :title="header"
  >
    <template v-slot:body>
      <ParagraphBody>
        <div v-if="body.length">
          <div
            v-for="text in body"
            :key="text"
          >
            <MarkdownInline :mdTemplate="text" />
          </div>
        </div>
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroup :isFullWidth="false">
        <ButtonNoBackground
          text="cancel"
          @click="handleClose"
        />
        <ButtonSecondary
          :text="actionText"
          type="error"
          @click="handleAction"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>
import * as Constants from 'client/util/Constants';
import {
  ButtonGroup,
  ButtonNoBackground,
  ButtonSecondary,
  MarkdownInline,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { notify } from 'client/util';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

const { error, success } = Constants.default;

export default {
  name: 'SystemEmmCommandsModal',

  components: {
    ButtonGroup,
    ButtonNoBackground,
    ButtonSecondary,
    MarkdownInline,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    actionEvent: {
      required: true,
      type: String,
    },
    actionText: {
      required: true,
      type: String,
    },
    body: {
      required: false,
      type: Array,
      default: () => [],
    },
    enableMainAction: {
      required: false,
      type: Boolean,
      default: true,
    },
    executeAction: {
      required: true,
      type: Function,
    },
    header: {
      required: true,
      type: String,
    },
    onSuccess: {
      required: false,
      type: String,
      default: '',
    },
  },

  methods: {
    handleAction() {
      this.executeAction()
        .then(() => {
          ModalEventBus.$emit(this.actionEvent);
          if (this.onSuccess.length > 0) notify(success, this.onSuccess);
        })
        .catch(() => {
          notify(error, 'An error occurred while attempting to perform this action.');
        })
        .finally(() => {
          ModalEventBus.close();
        });
    },

    handleClose() {
      ModalEventBus.close();
    },
  },
};
</script>

<style module>
.headerFontSize div div header h3 {
  font-size: var(--jcHeadingSmall) !important;
}
</style>
